
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specialisms",
      function () {
        return require("private-next-pages/specialisms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specialisms"])
      });
    }
  